module.exports = __webpack_public_path__ + "static/media/mole_checking@3x.923c64cc.png";